import  React, { useEffect } from 'react';
import Header from './header';
import Footer from './footer'; 
import { useLocation } from '@reach/router'; 
import HomeWithContentFooter from './home-with-content-footer';
import { useUserTracking } from '../services/trackingService';
import CustomCursor from "./CustomCursor"; 
import useScrollToTop from '../hook/useScrollToTop';
import HeaderBlog from './headerBlog';
const Layout = ({ pageTitle, children,browserClass,isBlog=false}) => {
   const location = useLocation();
  
        useUserTracking();
        useEffect(() => {
            const handlePopState = () => {
              window.scrollTo(0, 0);
            };
        
            window.addEventListener('popstate', handlePopState);
        
            return () => {
              window.removeEventListener('popstate', handlePopState);
            };
          }, []);
    return (

        <main className={browserClass?browserClass:'zuse-way-resp'}>
            <CustomCursor />
            {isBlog?<HeaderBlog/> :<Header />}
            {children}
            {location.pathname === '/home-with-content/' ? <HomeWithContentFooter /> : <Footer />}
        </main>

    )
} 
// Step 3: Export your component
export default Layout